import React, { useState } from 'react';

import getDate from '../../../../Helpers/Date/GetDate';
import CustomModal from '../../../../Components/CustomModal/CustomModal';
import {
  NewInvoiceIcon,
  NewSalesReturnIcon,
  NewSalesOrderIcon,
} from '../../../../Assets/Navigation/NavigationIcons';
import AddRetrunReceive from '../../../../Assets/General/AddRetrunReceive';
import InvoiceDetails from '../../../../Pages/SalesOrder/Invoices/InvoiceDetails/index';
import SalesReturnDetails from '../../../../Pages/SalesReturn/SalesReturnDetails/index';
import SalesOrderDetails from '../../../../Pages/SalesOrder/SalesOrderDetails/index';
import ReturnReceiveDetails from '../../../../Components/Form/ReturnReceive/ReturnReceiveDetails';
import { t } from 'i18next';

const PackageInfo = ({
  info: {
    creditNoteDate,
    salesOrderNo,
    InvoiceNo,
    InvoiceID,
    salesOrderID,
    ReturnReceiveNo,
    ReturnReceiveID,
    SaleReturnNo,
    SaleReturnID,
    // customerName,
    // customerID,
    // history,
    remaining_credits,
    totalInvoice,
    currency,
    // totalQuantity = 0,
  },
  inModal = false,
}) => {
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [showSRModal, setShowSRModal] = useState(false);
  const [showSOModal, setShowSOModal] = useState(false);
  const [showReturnReceiveViewModal, setShowReturnReceiveViewModal] =
    useState(false);
  function viewInvoiceModal() {
    return (
      <CustomModal
        Icon={NewInvoiceIcon}
        showModal={showInvoiceModal}
        title={t('CreditNote.view_invoice')}
        className="popup-height"
        modaltitle="inventory_modal_title"
        renderActions={false}
        size="large"
        onClose={() => setShowInvoiceModal(false)}
        linkTo={`invoices/${InvoiceID}`}
      >
        <InvoiceDetails id={InvoiceID} inModal={true} />
      </CustomModal>
    );
  }

  function viewSaleReturnModal() {
    return (
      <CustomModal
        showModal={showSRModal}
        title={t('CreditNote.view_sale_return')}
        renderActions={false}
        size="large"
        Icon={NewSalesReturnIcon}
        linkTo={`salesreturns/${SaleReturnID}`}
        onClose={() => setShowSRModal(false)}
      >
        <SalesReturnDetails id={SaleReturnID} inModal={true} />
      </CustomModal>
    );
  }
  function viewSaleOrderModal() {
    return (
      <CustomModal
        showModal={showSOModal}
        title={t('CreditNote.view_sale_order')}
        renderActions={false}
        size="large"
        Icon={NewSalesOrderIcon}
        linkTo={`salesorders/${salesOrderID}`}
        onClose={() => setShowSOModal(false)}
      >
        <SalesOrderDetails id={salesOrderID} inModal={true} />
      </CustomModal>
    );
  }

  function renderReturnReceiveModal() {
    return (
      <CustomModal
        showModal={showReturnReceiveViewModal}
        title={`${t('CreditNote.return_receive')} | ${ReturnReceiveNo}`}
        Icon={AddRetrunReceive}
        renderActions={false}
        size="medium"
        onClose={() => setShowReturnReceiveViewModal(false)}
        showActionInMenu={false} // true for make print pdf mail and delete option enable
        classNames="return-receive-popup"
      >
        <ReturnReceiveDetails inModal type="add" id={ReturnReceiveID} />
      </CustomModal>
    );
  }

  return (
    <>
      {viewInvoiceModal()}
      {viewSaleReturnModal()}
      {viewSaleOrderModal()}
      {renderReturnReceiveModal()}

      <div className="section-details--info position-relative mtb cn-summary-info">
        {creditNoteDate && (
          <div className="credit_feild">
            <div className="section-details--info-title semi-bold">
              {t('CreditNote.cn_date')}
            </div>
            <div className="">{getDate(creditNoteDate)}</div>
          </div>
        )}
        <hr />

        {salesOrderID && salesOrderNo && (
          <>
            <div className="credit_feild">
              <div className="section-details--info-title semi-bold">
                {t('CreditNote.so_no')}
              </div>
              {inModal ? (
                <div className="float-right">{salesOrderNo} </div>
              ) : (
                <div
                  onClick={() => setShowSOModal(true)}
                  className="float-right colorBlue pointer"
                >
                  {salesOrderNo}{' '}
                </div>
              )}
            </div>
            <hr />
          </>
        )}
        {SaleReturnID && SaleReturnNo && (
          <>
            <div className="credit_feild">
              <div className="section-details--info-title semi-bold">
                {t('CreditNote.sr_no')}
              </div>
              {inModal ? (
                <div className="float-right">{SaleReturnNo} </div>
              ) : (
                <div
                  onClick={() => setShowSRModal(true)}
                  className="float-right colorBlue pointer"
                >
                  {SaleReturnNo}{' '}
                </div>
              )}
            </div>
            <hr />
          </>
        )}
        {InvoiceID && InvoiceNo && (
          <>
            <div className="credit_feild">
              <div className="section-details--info-title semi-bold">
                {t('CreditNote.invoice_no')}
              </div>
              {inModal ? (
                <div className="float-right">{InvoiceNo} </div>
              ) : (
                <div
                  onClick={() => setShowInvoiceModal(true)}
                  className="float-right colorBlue pointer"
                >
                  {InvoiceNo}{' '}
                </div>
              )}
            </div>

            <hr />
          </>
        )}
        {ReturnReceiveNo && (
          <>
            <div className="credit_feild">
              <div className="section-details--info-title semi-bold">
                {t('CreditNote.rr_no')}
              </div>
              {inModal ? (
                <div className="semi-bold-amount">{ReturnReceiveNo}</div>
              ) : (
                <div
                  onClick={() => setShowReturnReceiveViewModal(true)}
                  className="float-right colorBlue pointer"
                >
                  {ReturnReceiveNo}{' '}
                </div>
              )}
            </div>
            <hr />
          </>
        )}

        {totalInvoice && (
          <>
            <div className="credit_feild">
              <div className="section-details--info-title semi-bold">
                {t('CreditNote.invoice_amount')}
              </div>
              <div className="semi-bold-amount">
                {currency.symbol}
                {totalInvoice.toFixed(2)}
              </div>
            </div>
            <hr />
          </>
        )}

        <>
          <div className="credit_feild">
            <div className="section-details--info-title semi-bold">
              {t('CreditNote.total_issue_credit')}
            </div>
            <div className="semi-bold-amount">
              {currency.symbol}
              {parseFloat(totalInvoice - remaining_credits).toFixed(2)}
            </div>
          </div>
        </>
      </div>
    </>
  );
};

export default PackageInfo;
